import React__default from 'react';
import { Row, Col } from '@sravni/react-design-system/lib/Grid';
import { useStyles } from '@sravni/react-utils';
import { ContentWidget } from '../../ContentWidget/src/ContentWidget.js';
import { MenuItem } from '../../MenuItem/src/MenuItem.js';
import modules_8fa60410 from '../styles/DesktopMenuDropdown.module.less.js';

const DesktopMenuDropdown = React__default.forwardRef((props, ref) => {
    const { item, isVisible, widgetSourceUrl, getRef, onItemClick: handleItemClick, ...restProps } = props;
    const cx = useStyles(modules_8fa60410);
    const hasWidget = !!widgetSourceUrl;
    return (React__default.createElement("div", { className: cx('dropdown', { dropdownVisible: isVisible }), ...restProps, ref: ref },
        React__default.createElement("div", { className: cx('dropdownContent') },
            React__default.createElement(Row, { gutter: 20 },
                item.children?.slice(0, hasWidget ? 2 : undefined).map((group) => (React__default.createElement(Col, { key: group.text, span: hasWidget ? 3 : 4, className: cx('menuItem') }, group.children?.map((menuItem) => (React__default.createElement(MenuItem, { ref: getRef?.(menuItem), key: menuItem.href, item: menuItem, onClick: handleItemClick, size: 16 })))))),
                hasWidget ? (React__default.createElement(Col, { span: 6 },
                    React__default.createElement(ContentWidget, { url: widgetSourceUrl }))) : null))));
});
DesktopMenuDropdown.displayName = 'DesktopMenuDropdown';

export { DesktopMenuDropdown };
//# sourceMappingURL=DesktopMenuDropdown.js.map
